export default __webpack_public_path__ + "static/media/left.9df58750.png";